var render = function render() {
  var _vm$sectionData, _vm$sectionData2;
  var _vm = this,
    _c = _vm._self._c;
  return _c("section", {
    staticClass: "post-section-3"
  }, [(_vm$sectionData = _vm.sectionData) !== null && _vm$sectionData !== void 0 && _vm$sectionData.image ? _c("img", {
    attrs: {
      src: _vm.urlForImage((_vm$sectionData2 = _vm.sectionData) === null || _vm$sectionData2 === void 0 ? void 0 : _vm$sectionData2.image).width(3000).url(),
      alt: "image"
    }
  }) : _vm._e()]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };